<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="安灯编号">
                    <el-input v-model.trim="andonCode" placeholder="请输入" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchTable">查询</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="安灯工单列表" ref="LabelContent">
            <div slot="btns">
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="andonCode" label="安灯编号" width="180"/>
                <el-table-column prop="sfName" label="所属机构" width="220">
                    <template slot-scope="scope">
                        <span>{{scope.row.fcName}}//{{scope.row.shopName}}//{{scope.row.sectionName}}//{{scope.row.lineName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="devCode" label="设备编号" width="120"/>
                <el-table-column prop="devName" label="设备名称" width="100"/>
                <el-table-column prop="atName" label="安灯类型" width="80"/>
                <el-table-column prop="acName" label="安灯种类" width="150" show-overflow-tooltip/>
                <el-table-column prop="andonStatus" label="安灯状态" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.andonStatus == 'create'">待接单</span>
                        <span v-if="scope.row.andonStatus == 'wait_complete'">待完成</span>
                        <span v-if="scope.row.andonStatus == 'wait_accept'">待验收</span>
                        <span v-if="scope.row.andonStatus == 'complete'">已完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pubUserName" label="发布人" width="100"/>
                <el-table-column prop="andonRespUserName" label="接单人" width="100"/>
                <el-table-column prop="moAdjustProdTime" label="实际影响时间" width="110">
                    <template slot-scope="scope">
                        <span>{{Math.floor(scope.row.moAdjustProdTime/60)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="andonProbDesc" label="问题描述" show-overflow-tooltip/>
                <el-table-column prop="aorSolveDesc" label="处理对策描述" width="110"/>
                <el-table-column prop="createTime" label="发布时间" width="160"/>
                <el-table-column prop="andonRespTime" label="接单时间" width="160"/>
                <el-table-column prop="moRepairStart" label="维修开始时间" width="160"/>
                <el-table-column prop="moRepairEnd" label="维修结束时间" width="160"/>
                <el-table-column prop="andonCloseTime" label="安灯关闭时间" width="160"/>
                <el-table-column prop="isEdit" label="是否编辑">
                    <template slot-scope="scope">
                        <span>{{scope.row.isEdit ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="arTrigger" label="当前安灯级别触发条件" width="220"/>
                <el-table-column prop="andonInitLevel" sortable label="安灯初始级别" width="105"/>
                <el-table-column prop="arLevel" sortable label="安灯当前级别" width="105"/>
                <el-table-column prop="checkInitLevel" sortable label="验收等级"/>
                <el-table-column prop="checkLevel" label="验收进度">
                    <template slot-scope="scope">
                        <span>{{scope.row.checkLevel == 0 ? '未开始': scope.row.checkLevel}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
                        <i class="editBtn iconfont u-youjianbianji" @click="EditorAndonOrder(scope.row)"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
    </div>
</template>

<script>
    import {
        andonContentList,
        AndonMailPushConfigList,
        deleteAndonOrder,
        exportAndonOrder,
        getAllAndonOrder,
        userMailList
    } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'andonOrderList',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                andonCode: '',
                tableData: []
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                let andonCode = ''
                //获取当前浏览器URL
                andonCode = window.location.href
                if (andonCode.indexOf('?andonCode') != -1) {
                    andonCode = andonCode.split('?andonCode=')[1]
                } else {
                    andonCode = ''
                }
                if (andonCode != undefined && andonCode != '' && andonCode != null) {
                    this.andonCode = andonCode
                }
                console.log('andonCode',andonCode)
                this.searchTable()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            searchTable() {
                this.tableData = []
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.andonCode != undefined && self.andonCode != '') {
                    queryParams['andonCode'] = self.andonCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getAllAndonOrder
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            //跳转工单详情页
            EditorAndonOrder(row) {
                this.$router.push({
                    path: '/andonOrderDetailJump',
                    query: {
                        andonCode: row.andonCode
                    }
                })
            },
            dateFormat(date) {
                return moment(date).format('YYYY-MM-DD')
            }
        }
    }
</script>

<style scoped>

</style>
